/**
 * Points and screen time constants
 */
/**
 * Conversion rate: 1 point = 1 minute of screen time
 */
export const POINT_TO_MINUTES = 1;
/**
 * Screen time reference cap (for progress bar)
 */
export const SCREEN_TIME_REFERENCE_CAP = 120; // minutes
//# sourceMappingURL=points.js.map